import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EkgDivider } from "@/components/Dividers";
import { Experience } from "@/components/Experience";
import { Pitch } from "@/components/Pitch";
import { Projects } from "@/components/Projects";
import { Contact } from "@/components/Contact";
import { ResumeGate } from "@/components/ResumeGate";
import { Footer } from "@/components/Footer";
import AdminResume from "@/pages/AdminResume";

const Portfolio = () => {
  useEffect(() => {
    const lenis = new Lenis({ anchors: true, lerp: 0.09, wheelMultiplier: 0.95 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="grain bg-[#050505] text-white min-h-screen" data-testid="portfolio-app">
      <div className="aurora" aria-hidden="true">
        <span className="aurora-blob aurora-a" />
        <span className="aurora-blob aurora-b" />
        <span className="aurora-blob aurora-c" />
      </div>
      <Nav />
      <main className="relative">
        <Hero />
        <div className="max-w-7xl mx-auto px-6 md:px-10 pt-6 -mb-6">
          <EkgDivider />
        </div>
        <Experience />
        <Projects />
        <Pitch />
        <Contact />
        <ResumeGate />
      </main>
      <Footer />
    </div>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#111", border: "1px solid rgba(255,20,147,0.4)", color: "#fff" } }} />
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/admin/resume" element={<AdminResume />} />
      </Routes>
    </BrowserRouter>
  );
}
